import { Badge, Text, Tooltip, VStack } from '@elkaso-app/web-design';
import React from 'react';

export interface DedNameCellProps {
  businessName: string;
  licenseConfidence: number;
}

export const DedNameCell: React.FC<DedNameCellProps> = ({ businessName, licenseConfidence }) => (
  <div style={{ height: '80px', display: 'flex', alignItems: 'center', padding: '8px 0', maxWidth: '100%' }}>
    <VStack align='start' spacing={1} maxW='100%'>
      {businessName ? (
        <>
          <Tooltip label={businessName} isDisabled={businessName?.length <= 25}>
            <Text
              fontWeight='medium'
              fontSize='md'
              color='green.600'
              lineHeight='1.2'
              maxW='100%'
              wordBreak='break-word'
              whiteSpace='normal'
              noOfLines={2}>
              {businessName}
            </Text>
          </Tooltip>
          <Badge colorScheme='green' variant='subtle' size='sm'>
            Confidence: {Math.round(licenseConfidence * 100)}%
          </Badge>
        </>
      ) : (
        <Text fontSize='sm' color='gray.500' fontStyle='italic'>
          DED business name not available
        </Text>
      )}
    </VStack>
  </div>
);
